import portfolioImg1 from "../../assets/Slide8.jpg";
import portfolioImg2 from "../../assets/Slide9.jpg";
import portfolioImg3 from "../../assets/Slide6.jpg";
import portfolioImg4 from "../../assets/Slide10.jpg";
import portfolioImg5 from "../../assets/portfolio-9.jpg";
import portfolioImg6 from "../../assets/Slide4.jpg";
import portfolioImg7 from "../../assets/Slide15.jpg";
import portfolioImg8 from "../../assets/Slide2.jpg";
import portfolioImg9 from "../../assets/portfolidgfho-2.jpg";
import portfolioImg10 from "../../assets/portfolio-1.jpg";
import portfolioImg11 from "../../assets/Slide14.jpg";
import portfolioImg12 from "../../assets/portfolio-3.jpg";
import portfolioImg18 from "../../assets/portfolio-4.jpg";
import portfolioImg14 from "../../assets/portfolio-5.jpg";
import portfolioImg15 from "../../assets/portfolio-6.jpg";
import portfolioImg16 from "../../assets/portfolio-7.jpg";
import portfolioImg17 from "../../assets/portfolio-8.jpg";
import portfolioImg13 from "../../assets/portfodgdlio-3.jpg";

const portfolioItems = [
  {
    id: 1,
    img: portfolioImg1,
    width: 1080,
    height: 780,

    category: "AI",
    title: "AI",
    description: "First website",
  },
  {
    id: 2,
    img: portfolioImg2,
    width: 1080,
    height: 620,
    category: "mobile",
    title: "mobile1",
    description: "first mobile app",
  },
  {
    id: 3,
    img: portfolioImg3,
    width: 1080,
    height: 720,
    category: "AI",
    title: "AI",
    description: "Second website",
  },
  {
    id: 4,
    img: portfolioImg4,
    category: "mobile",
    title: "mobile2",
    description: "second mobile app",
    width: 1080,
    height: 721,
  },
  // {
  //   id: 5,
  //   img: portfolioImg5,
  //   category: "3D",
  //   title: "3D",
  //   description: "first desktop app",
  //   width: 1080,
  //   height: 620,
  // },
  {
    id: 6,
    img: portfolioImg6,
    category: "AI",
    title: "AI",
    description: "Third website",
    width: 1080,
    height: 900,
  },
  // {
  //   id: 7,
  //   img: portfolioImg7,
  //   category: "mobile",
  //   title: "mobile3",
  //   description: "third mobile app",
  //   width: 1080,
  //   height: 608,
  // },
  {
    id: 8,
    img: portfolioImg8,
    category: "AI",
    title: "AI",
    description: "Forth website",
    width: 1080,
    height: 720,
  },
  {
    id: 9,
    img: portfolioImg9,
    category: "3D",
    title: "3D",
    description: "second desktop app",
    width: 1080,
    height: 620,
  },
  {
    id: 10,
    img: portfolioImg10,
    width: 1080,
    height: 780,

    category: "AI",
    title: "AI",
    description: "First website",
  },
  {
    id: 11,
    img: portfolioImg11,
    width: 1080,
    height: 620,
    category: "mobile",
    title: "mobile1",
    description: "first mobile app",
  },
  {
    id: 12,
    img: portfolioImg12,
    width: 1080,
    height: 720,
    category: "AI",
    title: "AI",
    description: "Second website",
  },
  {
    id: 13,
    img: portfolioImg13,
    category: "mobile",
    title: "mobile2",
    description: "second mobile app",
    width: 1080,
    height: 721,
  },
  {
    id: 14,
    img: portfolioImg14,
    category: "AI",
    title: "AI",
    description: "first desktop app",
    width: 1080,
    height: 620,
  },
  {
    id: 15,
    img: portfolioImg15,
    category: "AI",
    title: "AI",
    description: "Third website",
    width: 1080,
    height: 900,
  },
  {
    id: 16,
    img: portfolioImg16,
    category: "mobile",
    title: "mobile3",
    description: "third mobile app",
    width: 1080,
    height: 608,
  },
  {
    id: 17,
    img: portfolioImg17,
    category: "AI",
    title: "AI",
    description: "Forth website",
    width: 1080,
    height: 720,
  },
  {
    id: 18,
    img: portfolioImg18,
    category: "3D",
    title: "3D",
    description: "second desktop app",
    width: 1080,
    height: 620,
  },
];
const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];
export const portfolioPhotos = portfolioItems.map((item) => {
  const width = breakpoints[0];
  const height = (item.height / item.width) * width;

  return {
    src: item.img,
    width,
    height,
    title: item.title,
    category: item.category,
    description: item.description,
    images: breakpoints.map((breakpoint) => {
      const height = Math.round((item.height / item.width) * breakpoint);
      return {
        src: item.img,
        width: breakpoint,
        height,
      };
    }),
  };
});
export const categories = [
  "all",
  ...new Set(portfolioItems.map(({category}) => category)),
];
